import * as React from 'react';
import { SystemDetailedIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const FacebookDetailedIcon = ({ size = 16 }: SystemDetailedIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 12 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M3.492 19.854v-8.622H.25V7.806h3.242V5.107c0-2.933 2.012-4.529 4.95-4.529 1.408 0 2.617.094 2.967.136v3.064H9.372c-1.598 0-1.906.678-1.906 1.668v2.36h3.605l-.494 3.426H7.466v8.622"
            fill="#1877F2"/>
    </svg>
);
FacebookDetailedIcon.displayName = 'FacebookDetailedIcon';
export default FacebookDetailedIcon;
